// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const Select = styled.select`
  -webkit-appearance: none;
  appearance: none;
  width: 88px;
  height: 100%;
  min-height: 48px;
  border: 1px solid #cfd4d9;
  padding: 10px 30px 10px 14px;
  border-radius: 999px;
  position: relative;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  text-align-last: center;
  color: ${({ theme }) => theme.colors.ink};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.grafanaOrange};
    box-shadow: 0 0 0 3px rgba(244, 104, 0, 0.15);
  }
`;

export const SelectContainer = styled.div`
  position: relative;
  width: min-content;
`;

export const Arrow = styled.img.attrs({
  src: '/icons/Chevron.svg',
  alt: '',
})`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 12px;
  opacity: 0.6;
  pointer-events: none;
`;
